import { gerarParcelas } from '@core/util/parcelaUtil';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { cancelarAlert, excluirAlert } from 'app/services/alerts';
import ContasPagarApi from 'app/services/api/contasPagarApi';
import { relatorioApi } from 'app/services/api/relatorioApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';
import { eventReactGA } from 'app/utils/analyticsUtil';
import moment from 'moment';
import NP from 'number-precision';
import { contasPagarTour } from '../../../../@core/util/mockTourUtils';
import { visualizarRelatorioV2 } from '../../../utils/enviromentUtil';

const CONTA_PAGAR = 'Conta a pagar';
const CONTASPAGAR = '[CONTASPAGAR]';
const FECHAR_MODAL = `${CONTASPAGAR}_FECHAR_MODAL`;
const BAIXA_CONTA_PAGAR = `${CONTASPAGAR}_BAIXA_CONTA_PAGAR`;
const BUSCAR_SOMATORIOS = `${CONTASPAGAR}_BUSCAR_SOMATORIOS`;
const SELECIONAR_ABA_CADASTRO = `${CONTASPAGAR}_SELECIONAR_ABA_CADASTRO`;
const SET_FILTRO_AVANCADO = `${CONTASPAGAR}_SET_FILTRO_AVANCADO`;
const SET_FILTRO_AVANCADO_FORMATADO = `${CONTASPAGAR}_SET_FILTRO_AVANCADO_FORMATADO`;
const SET_ARQUIVO_IMPORT = `${CONTASPAGAR}_SET_ARQUIVO_IMPORT`;

export const initRetencoes = { dataVencimento: null };
export const initContasPagar = {
  origemLancamento: 'CONTA_PAGAR',
  dataVencimento: null,
  dataEmissao: null,
  tipoDespesa: 'UNICA',
  competencia: null,
  fornecedor: null,
  favorecido: null,
  favorecidoDiferenteFornecedor: false,
  categorias: [
    { classe: undefined, valorBruto: undefined, descricao: undefined, rateios: [{ classe: {}, percentual: '' }] },
  ],
  parcelamento: undefined,
  retencoes: undefined,
  repetirLancamento: false,
  frequencia: undefined,
  quantidade: undefined,
  numeroParcelas: undefined,
  linhaDigitavel: undefined,
  gerarParcelasCount: 0,
};

const types = generateActionTypes(CONTASPAGAR);

export const ContasPagarTypes = {
  ...types,
  FECHAR_MODAL,
  BAIXA_CONTA_PAGAR,
  BUSCAR_SOMATORIOS,
  SELECIONAR_ABA_CADASTRO,
  SET_FILTRO_AVANCADO,
  SET_FILTRO_AVANCADO_FORMATADO,
  SET_ARQUIVO_IMPORT,
};

const defaultActions = generateDefaultActions(ContasPagarTypes);

const setFiltroAvancadoFormatado = (dispatch, filtroAvancadoFormatado) => {
  dispatch({ type: SET_FILTRO_AVANCADO_FORMATADO, payload: filtroAvancadoFormatado });
};

const setFiltroAvancado = (dispatch, filtroAvancado) => {
  dispatch({ type: SET_FILTRO_AVANCADO, payload: filtroAvancado });
};

const abrirImportModal = () => ({
  type: ContasPagarTypes.ABRIR_IMPORT_MODAL,
});

const fecharImportModal = () => ({
  type: ContasPagarTypes.FECHAR_IMPORT_MODAL,
});

function setArquivoImport(dispatch, file) {
  dispatch({
    type: ContasPagarTypes.SET_ARQUIVO_IMPORT,
    payload: file,
  });
}

async function carregarRegistros(dispatch, queryParams = {}, filtroAvancadoFormatado = {}) {
  try {
    dispatch(ContasPagarAction.setCarregandoRegistros(true));

    const filtro = {
      ...queryParams,
      ...filtroAvancadoFormatado,
      query: queryParams.q,
    };

    const resp = await ContasPagarApi.buscar(filtro);

    if (filtroAvancadoFormatado.origemConciliacao === true && filtroAvancadoFormatado.situacao === 'TODAS') {
      resp.data.content.forEach((conta) => {
        if (conta?.situacao === 'EXCLUIDA') {
          resp.data.content = resp.data.content.filter((item) => item !== conta);
        }
      });
    }

    if (filtroAvancadoFormatado.situacao === 'BAIXADA') {
      resp.data.content.forEach((conta) => {
        if (conta?.situacao === 'PARCIALMENTE_BAIXADA' && !conta?.baixas) {
          resp.data.content = resp.data.content.filter((item) => item !== conta);
        }
      });
    }

    if (filtroAvancadoFormatado.situacao === 'ABERTA') {
      resp.data.content.forEach((conta) => {
        if (conta?.situacao === 'PARCIALMENTE_BAIXADA' && conta?.baixas) {
          resp.data.content = resp.data.content.filter((item) => item !== conta);
        }
      });
    }

    dispatch(ContasPagarAction.setCurrentPage(resp.data.number));
    dispatch(ContasPagarAction.setPageSize(resp.data.size));
    dispatch(ContasPagarAction.buscar(resp.data));
  } finally {
    dispatch(ContasPagarAction.setCarregandoRegistros(false));
  }
}

async function buscarTour(dispatch) {
  dispatch(ContasPagarAction.setCarregandoRegistros(true));
  dispatch(ContasPagarAction.buscar(contasPagarTour));
  dispatch(ContasPagarAction.setCurrentPage(contasPagarTour.page));
  dispatch(ContasPagarAction.setPageSize(contasPagarTour.size));
  dispatch(ContasPagarAction.setCarregandoRegistros(false));
}

const requestVisualizar = async (dispatch, id, state) => {
  try {
    dispatch(ContasPagarAction.carregandoRegistro(true));

    const response = await ContasPagarApi.buscarPorId(id[0]);

    if (id.length > 1) {
      const responseBaixa = await ContasPagarApi.buscarPorId(id[1]);
      if (responseBaixa?.data?.baixa) {
        state = {
          ...state,
          retencaoDespesaOrigemId: id[0],
          baixa: responseBaixa?.data?.baixa,
        };
      }
    }

    let historico = [];
    try {
      const responseHistorico = await ContasPagarApi.buscarHistorico(id[0]);
      historico = responseHistorico?.data || [];
    } catch (error) {
      historico = [];
    }

    dispatch(ContasPagarAction.visualizar({ ...response.data, ...state, historico }));
  } finally {
    dispatch(ContasPagarAction.carregandoRegistro(false));
  }
};

const buscarSomatorio = async (dispatch, filtro) => {
  try {
    const response = await ContasPagarApi.somatorio(filtro);
    dispatch({ type: BUSCAR_SOMATORIOS, payload: response.data });
  } finally {
    dispatch(ContasPagarAction.carregandoRegistro(false));
  }
};

const selecionarAbaCadastro = async (dispatch, aba) => {
  try {
    dispatch({ type: SELECIONAR_ABA_CADASTRO, payload: aba });
  } catch (error) {
    console.error(error);
  }
};

const requestEditar = async (dispatch, id) => {
  try {
    dispatch(ContasPagarAction.carregandoRegistro(true));
    const response = await ContasPagarApi.buscarPorId(id);

    const { data } = response;

    if (data?.dataEmissao) {
      data.dataEmissao = moment(data.dataEmissao);
    }

    if (data?.dataVencimento) {
      data.dataVencimento = moment(data.dataVencimento);
    }

    if (data?.parcelamento?.parcelas?.length) {
      data.parcelamento.parcelas = data.parcelamento.parcelas.map((parcela) => ({
        ...parcela,
        dataVencimento: moment(parcela.dataVencimento),
        informarCodigoBarras: !!parcela.linhaDigitavel,
      }));
      data.numeroParcelas = data.parcelamento.parcelas.length;
    }

    if (data?.retencoes?.length) {
      data.retencoes = data.retencoes.map((retencao) => ({
        ...retencao,
        dataVencimento: moment(retencao.dataVencimento),
      }));
    }

    if (data.tipoDespesa === 'LINHA_DIGITAVEL' || data.tipoDespesa === 'PARCELADA') {
      data.valorTotal = data.valorBruto;
    }

    // Gambiarra para conseguir gerar novas parcelas sem gerar novas parcelas quando a origem é compra conforme pedido em GFST2021-37
    if (data?.origemLancamento?.includes('COMPRA')) {
      data.parcelasCompra = data?.parcelamento?.parcelas;
      data.retencoesCompra = data?.retencoes;
    }

    dispatch(ContasPagarAction.editar(data));
  } finally {
    dispatch(ContasPagarAction.carregandoRegistro(false));
  }
};

function excluir(dispatch, idsSelecionados, params, tipoSelecao) {
  excluirAlert({
    opcoes: {
      title:
        'Ao excluir a despesa, todas as despesas vinculadas à ela também serão excluídas, caso existam. Deseja continuar?',
    },
    confirmar: async () => {
      dispatch(ContasPagarAction.setCarregandoRegistros(true));
      try {
        eventReactGA(CONTA_PAGAR, 'Excluir conta a pagar');
        await ContasPagarApi.excluir({ ids: idsSelecionados, query: params.q, tipoSelecao });

        dispatch(ContasPagarAction.sucesso('Conta a pagar excluída com sucesso'));
        dispatch(ContasPagarAction.limparSelecao());
        carregarRegistros(dispatch, params);
      } catch (error) {
        dispatch(ContasPagarAction.erro(error?.response?.data.message));
      } finally {
        dispatch(ContasPagarAction.setCarregandoRegistros(false));
      }
    },
  });
}

function fecharModalCadastro(dispatch, dirty) {
  const action = {
    type: ContasPagarTypes.FECHAR_MODAL,
  };

  if (dirty) {
    cancelarAlert({
      confirmar: async () => {
        dispatch(action);
      },
    });
  } else {
    dispatch(action);
  }
}

async function onSubmit(dispatch, contasPagar, requestParams, filtroAvancado) {
  dispatch(ContasPagarAction.setCarregarRegistro(true));
  const _contaPagar = JSON.parse(JSON.stringify(contasPagar));

  // removendo as baixas que já estão salvas no banco antes de adicionar a nova (importante para que não haja duplicidade)
  _contaPagar.baixas = undefined;

  if (_contaPagar?.parcelamento?.parcelas?.length) {
    _contaPagar.parcelamento.parcelas = _contaPagar.parcelamento.parcelas.map((parcela) => ({
      ...parcela,
      linhaDigitavel: parcela?.informarCodigoBarras ? parcela.linhaDigitavel : null,
    }));
  }

  if (_contaPagar?.baixa && !_contaPagar?.baixa?.dataPagamento) {
    delete _contaPagar.baixa;
  }

  if (!_contaPagar.recorrencia?.repetirLancamento) {
    delete _contaPagar.recorrencia;
  }

  if (_contaPagar?.baixa) {
    _contaPagar.baixas = [_contaPagar.baixa];
    _contaPagar.baixa = undefined;
  }

  try {
    if (_contaPagar.retencoes?.length > 0) {
      const retencoes = _contaPagar.retencoes?.filter(
        (retencao) => !!retencao.imposto?.id && !!retencao.dataVencimento && !!retencao.valor && retencao.valor > 0
      );
      if (retencoes.length !== _contaPagar.retencoes?.length) {
        if (retencoes.length === 0) {
          delete _contaPagar.retencoes;
        } else {
          _contaPagar.retencoes = retencoes;
        }
      }
    }
    if (_contaPagar.id) {
      eventReactGA(CONTA_PAGAR, 'Atualizar conta a pagar');
      const response = await ContasPagarApi.atualizar(_contaPagar.id, _contaPagar);

      let message = 'Conta a pagar editada com sucesso';

      if (response?.data?.atributoOrigemCompraAlterado) {
        message = 'Conta a pagar editada com sucesso. As alterações feitas refletirão na compra.';
      }

      dispatch(ContasPagarAction.sucesso(message, _contaPagar));
    } else {
      eventReactGA(CONTA_PAGAR, 'Cadastrar conta a pagar');
      await ContasPagarApi.cadastrar(_contaPagar);
      dispatch(ContasPagarAction.sucesso('Conta a pagar salva com sucesso', _contaPagar));
    }

    dispatch(ContasPagarAction.limparSelecao());
    carregarRegistros(dispatch, requestParams, filtroAvancado);
    buscarSomatorio(dispatch, {
      ids: [],
      query: requestParams.q,
      tipoSelecao: 'NENHUM',
    });
  } catch (error) {
    if (error?.response?.data?.errorKey === 'conta.contaDuplicada') {
      cancelarAlert({
        opcoes: {
          title:
            'O número do documento fiscal informado já foi cadastrado para este fornecedor. Tem certeza que deseja continuar?',
          text: '',
        },
        aceitarTexto: 'OK',
        recusarTexto: 'Cancelar',
        confirmar: async () => {
          dispatch(ContasPagarAction.setCarregarRegistro(true));
          if (_contaPagar.id) {
            eventReactGA(CONTA_PAGAR, 'Atualizar conta a pagar');
            const response = await ContasPagarApi.atualizar(_contaPagar.id, _contaPagar, true);

            let message = 'Conta a pagar editada com sucesso';

            if (response?.data?.atributoOrigemCompraAlterado) {
              message = 'Conta a pagar editada com sucesso. As alterações feitas refletirão na compra.';
            }

            dispatch(ContasPagarAction.sucesso(message, _contaPagar));
          } else {
            eventReactGA(CONTA_PAGAR, 'Cadastrar conta a pagar');
            await ContasPagarApi.cadastrar(_contaPagar, true);
            dispatch(ContasPagarAction.sucesso('Conta a pagar salva com sucesso', _contaPagar));
          }
          dispatch(ContasPagarAction.limparSelecao());
          carregarRegistros(dispatch, requestParams, filtroAvancado);
          buscarSomatorio(dispatch, {
            ids: [],
            query: requestParams.q,
            tipoSelecao: 'NENHUM',
          });
          dispatch(ContasPagarAction.setCarregarRegistro(false));
        },
      });
    }
    if (error?.response?.data?.errorKey !== 'conta.contaDuplicada') {
      if (error?.response?.data?.fieldErrors?.length) {
        const err = error.response.data.fieldErrors[0];
        dispatch(ContasPagarAction.erro(`${err?.field}: ${err?.message}`, _contaPagar));
      } else {
        dispatch(
          ContasPagarAction.erro(
            error?.response?.data?.message?.replace('error.', '').replace('error.', ''),
            _contaPagar
          )
        );
      }
    }
  } finally {
    dispatch(ContasPagarAction.setCarregarRegistro(false));
  }
}

async function baixarContas(dispatch, values, requestParams = {}, filtroAvancado = {}) {
  try {
    dispatch(ContasPagarAction.setCarregarRegistro(true));

    const baixas = [];
    values.contas.forEach((conta) => {
      const despesaBaixa = {
        despesaId: conta.id,
        baixas: [
          {
            ...values.baixa,
            contaId: values.baixa.conta.id,
            origemBaixa: 'CONTA_PAGAR',
          },
        ],
      };

      if (values.contas.length > 1) {
        despesaBaixa.baixas[0].valorPago = conta?.valorLiquido;
      }

      delete despesaBaixa.baixas.conta;
      baixas.push(despesaBaixa);
    });

    eventReactGA(CONTA_PAGAR, 'Baixar');
    await ContasPagarApi.baixarContas(baixas);
    dispatch(ContasPagarAction.sucesso('Despesa baixada com sucesso.', baixas));

    const listaIdsContasPagar = values.contas.map((c) => c.id);
    if (values?.baixa?.emitirRecibo) {
      // visualizarRelatorio(listaIdsContasPagar, 'conta-pagar/recibo', `titulo=recibos`);
      const response = await relatorioApi().salvarFiltroRecibo(listaIdsContasPagar);
      visualizarRelatorioV2(response.data);
    }
    if (values?.baixa?.emitirDetalhes) {
      const response = await relatorioApi().salvarFiltroEmitirDetalhesBaixaContaPagar(listaIdsContasPagar);
      visualizarRelatorioV2(response.data);
      //visualizarRelatorio(listaIdsContasPagar, 'conta-pagar/detalhes', `titulo=detalhes`);
    }

    dispatch(ContasPagarAction.limparSelecao());
    carregarRegistros(dispatch, requestParams, filtroAvancado);
    buscarSomatorio(dispatch, {
      ids: [],
      query: requestParams.q,
      tipoSelecao: 'NENHUM',
    });
  } catch (error) {
    dispatch(ContasPagarAction.erro(error?.response?.data?.message, values));
  } finally {
    dispatch(ContasPagarAction.setCarregarRegistro(false));
  }
}

async function requestBaixa(dispatch, contas) {
  const baixa = { dataPagamento: moment(new Date()), dataLiquidacao: moment(new Date()) };
  if (contas.length === 1) {
    const response = await ContasPagarApi.buscarPorId(contas[0].id);
    const { retencoes, retencaoId } = response.data;

    if (contas[0].parcelamentoDespesaOrigemId) {
      const parcelamentoDespesaOrigem = await ContasPagarApi.buscarPorId(contas[0].parcelamentoDespesaOrigemId);
      baixa.parcelas = parcelamentoDespesaOrigem?.data?.parcelamento?.parcelas;
    }

    if (retencoes && retencaoId) {
      const retencaoSelecionada = retencoes?.find((retencao) => retencao.id === retencaoId);
      baixa.conta = retencaoSelecionada.conta;
      baixa.formaPagamento = retencaoSelecionada.formaPagamento;
      baixa.numeroCheque = retencaoSelecionada.numeroCheque;
      baixa.valorPago = undefined;
    } else {
      baixa.conta = contas[0].conta;
      baixa.formaPagamento = contas[0].formaPagamento;
      baixa.numeroCheque = contas[0].numeroCheque;
      baixa.valorPago = undefined;
    }
  }
  dispatch({ type: BAIXA_CONTA_PAGAR, payload: { contas, baixa } });
}

async function cancelarBaixas(dispatch, contas, params, filtroAvancado) {
  const baixaConciliada = verificarBaixaConciliada(contas);
  const temContasOrigensDistintas = baixaConciliada && verificarContasOrigensDistintas(contas);
  const todasOrigemConciliacao = verificarTodasContasOrigemConciliacao(contas);

  const quantidadeContas = contas?.length || 0;

  const mensagens = {
    titulo: baixaConciliada
      ? temContasOrigensDistintas
        ? 'Há contas selecionadas de origens distintas. As contas originadas pela conciliação bancária serão excluídas. Deseja continuar?'
        : todasOrigemConciliacao
          ? 'Essa conta será desconciliada e excluída, pois foi originada na conciliação bancária. Deseja continuar?'
          : 'Essa conta será desconciliada e a baixa cancelada. Deseja continuar?'
      : 'Tem certeza que deseja cancelar a(s) baixas?',

    sucesso: todasOrigemConciliacao
      ? 'O cancelamento da baixa foi realizado e a conta foi excluída com sucesso.'
      : baixaConciliada && !temContasOrigensDistintas
        ? 'Desconciliação realizada com sucesso.'
        : quantidadeContas === 1
        ? 'Baixa cancelada com sucesso.'
        : 'Baixa(s) cancelada(s) com sucesso.',
  };

  const despesasIds = contas.map((conta) => conta.id);

  const confirmarCancelamento = async () => {
    try {
      dispatch(ContasPagarAction.setCarregarRegistro(true));

      eventReactGA(CONTA_PAGAR, 'Cancelar baixa');
      await ContasPagarApi.cancelarBaixas(despesasIds);

      dispatch(ContasPagarAction.sucesso(mensagens.sucesso, despesasIds));
      dispatch(ContasPagarAction.limparSelecao());
      carregarRegistros(dispatch, params, filtroAvancado);
    } catch (error) {
      dispatch(ContasPagarAction.erro(error?.response?.data?.message || 'Erro ao cancelar baixa.', contas));
    } finally {
      dispatch(ContasPagarAction.setCarregarRegistro(false));
    }
  };

  excluirAlert({
    opcoes: { title: mensagens.titulo },
    confirmar: confirmarCancelamento,
  });
}

/*
RNE-107 - Sobre o campo "Diferença" das parcelas : Public <<Functional>> Feature
Created:	23/03/2020 09:41:24
Modified:	26/06/2020 17:55:04
Project:	
Advanced:	
O sistema deve exibir, na última linha depois das parcelas, a diferença do valor total bruto para o somatório dos valores líquidos das parcelas e valores das retenções.

Diferença = Valor total - (Somatório dos valores informados nas parcelas + Somatório dos valores das retenções).

Se o Somatório dos valores informados nas parcelas + Somatório dos valores das retenções for igual ao valor total, o sistema não deve exibir a diferença.
*/
const calcularDiferencaParcelas = (values) => {
  const valorParcelasRetenções = NP.plus(calcularParcelas(values), calcularValorRetencoes(values));
  return values.valorTotal && NP.minus(values.valorTotal, valorParcelasRetenções);
};

const calcularParcelas = (values) => {
  return values.parcelamento.parcelas
    .map((parcela) => parcela.valorLiquido)
    .reduce((acc, valorParcela) => NP.plus(acc, valorParcela || 0), 0);
};

/*
RNE-104 - Sobre o campo "Diferença" - Categorias : Public <<Functional>> Feature
O sistema deve exibir, na última linha depois da categoria, a diferença do valor total com o somatório dos valores informados por categoria.
Se o somatório for igual ao valor total, o sistema não deve exibir a diferença.
O sistema deverá validar se o somatório dos valores informados para as categorias é igual ao valor total.
O sistema somente deve permitir o lançamento caso os valores estejam iguais.

Diferença = Valor total - Somatório dos valores informados nas categorias.

*/
const calcularDiferencaCategorias = (values) => {
  return values.valorTotal && NP.minus(values.valorTotal, calcularValorCategoria(values));
};

const calcularValorCategoria = (values) => {
  return values.categorias
    .map((categoria) => categoria.valorBruto)
    .reduce((acc, valorCategoria) => NP.plus(acc, valorCategoria || 0), 0);
};

const calcularValorRetencoes = (values) => {
  const { retencoes = [] } = values;
  return retencoes.map((retencao) => retencao.valor).reduce((acc, valor) => NP.plus(acc, valor || 0), 0);
};

const calcularValorTotalBruto = (values) => {
  return calcularValorCategoria(values);
};

/*
RNE-089 - Cálculo do valor líquido : Public <<Functional>> Feature
                	
O valor total líquido na aba "Retenções" é calculado da seguinte forma:
Valor total líquido = Valor total bruto - somatório total dos valores de impostos informados
                */
const calcularValorTotalLiquido = (values) => {
  return NP.minus(calcularValorTotalBruto(values), calcularValorRetencoes(values));
};

/*
RNE-081 - Exibição das categorias da despesa
O sistema deve exibir, na coluna "Categoria", a categoria informada no lançamento da despesa. 
Caso a despesa tenha mais de uma categoria associada, o sistema deve exibir o texto "Categorias diversas".

*/

const categoriaFormat = (contasPagar) => {
  if (contasPagar.categorias && contasPagar.categorias.length) {
    if (contasPagar.categorias.length > 1) {
      return 'Categorias diversas';
    }
    return `${contasPagar.categorias[0].classe.indice} ${contasPagar.categorias[0].classe.nome}`;
    // return `${contasPagar.categorias[0].classe.nome}`;
  }
};

const contaBancariaFormat = (conta) => {
  const agenciaDigito = conta?.contaBancaria?.agenciaDigito ? `-${conta?.contaBancaria?.agenciaDigito}` : '';
  const descricao = conta?.descricao;
  const agencia = conta?.contaBancaria?.agencia;
  const numeroConta = conta?.contaBancaria?.numeroConta;
  const contaDigito = conta?.contaBancaria?.contaDigito;

  if (agenciaDigito && descricao && agencia && numeroConta && contaDigito) {
    return `${descricao} ${agencia}${agenciaDigito}/${numeroConta}-${contaDigito}`;
  }
  if (descricao) {
    return `${descricao}`;
  }

  return '';
};

/*
RNE-082
*/

const parcelaFormat = (contasPagar) => {
  if (contasPagar?.parcela && contasPagar?.numeroParcelas) {
    return ` - ${contasPagar.parcela}/${contasPagar.numeroParcelas}`;
  }

  return '';
};

const documentoFiscalFormat = (contasPagar) => {
  if (contasPagar?.documentoFiscal) {
    return `Documento fiscal: ${contasPagar.documentoFiscal}`;
  }

  return '';
};

const nomeImpostoFormat = (imposto) => {
  if (imposto?.nome && imposto?.aliquota) {
    return `${imposto.nome} - ${imposto.aliquota}%`;
  }

  return '-';
};

/*
RNE-115 - Comando "Excluir" - C.P. : Public <<Functional>> Feature 
O usuário poderá excluir apenas contas abertas. 
 Portanto, o comando "Excluir" não será exibido quando a situação selecionada no filtro for igual a "Baixada" ou "Excluída".
*/
const verificarExibicaoBotaoExcluir = (tipoSelecao, selecionados) => {
  return (
    tipoSelecao === 'TODOS_FILTRO' ||
    (selecionados && selecionados.length > 0 && selecionados.every((cp) => cp.situacao === 'ABERTA'))
  );
};

const verificarExibicaoBotaoCancelarBaixa = (tipoSelecao, selecionados) => {
  return (
    tipoSelecao === 'TODOS_FILTRO' ||
    (selecionados && selecionados.length > 0 && selecionados.every((cp) => !!cp.baixas?.length > 0))
  );
};

const verificarExibicaoBotaoBaixar = (tipoSelecao, selecionados) => {
  if (permissaoUtils.contaPagar().editar)
    return (
      tipoSelecao === 'TODOS_FILTRO' ||
      (selecionados &&
        selecionados.length > 0 &&
        selecionados.every((cp) => cp.situacao === 'ABERTA' || cp.situacao === 'PARCIAL'))
    );
};

const verificarExibicaoEditarVisualizar = (registro) => {
  return registro?.situacao !== 'EXCLUIDA';
};

const calcularValorPagar = (conta) => {
  const desconto = conta?.baixa?.desconto?.valor ? conta?.baixa?.desconto?.valor : 0;
  const multa = conta?.baixa?.multa?.valor ? conta?.baixa?.multa?.valor : 0;
  const juros = conta?.baixa?.juros?.valor ? conta?.baixa?.juros?.valor : 0;
  const totais = NP.plus(conta?.contas?.[0].valorLiquido, multa, juros);
  return NP.minus(totais, desconto);
};

function arredondaCasasDecimais(value, decimals) {
  return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);
}

const verificarBaixaConciliada = (contas) => {
  if (!contas || contas.length === 0) {
    return false;
  }

  return contas.some((conta) => conta.conciliado === true);
};

const verificarContasOrigensDistintas = (contas) => {
  if (!contas || contas.length <= 1) {
    return false;
  }
  const temConciliada = contas.some((conta) => conta.conciliado === true);
  const temNaoConciliada = contas.some((conta) => conta.conciliado !== true);
  return temConciliada && temNaoConciliada;
};

const verificarTodasContasOrigemConciliacao = (contas) => {
  if (!contas || contas.length === 0) {
    return false;
  }
  return contas.every((conta) => conta.origemLancamento === 'CONCILIACAO');
};

/*
RNE-105 - Sobre a exibição das parcelas da despesa : Public <<Functional>> Feature

O sistema deverá exibir os campos, após o usuário acionar o comando "Gerar", 
conforme informações passadas sobre o parcelamento As parcelas corresponderão ao mês competência do vencimento.

Exemplo: Se o usuário informar que são 4 parcelas de R$1.000,00 com a data de vencimento 
da 1ª parcela 06/02/2018.
O sistema deve exibir, após o usuário "Gerar", 4 linhas diferentes para demonstrar as parcelas,
todas contendo R$1.000,00 e com os vencimentos correspondentes a cada mês (06/02/2018, 06/03/2018, 06/04/2018 e 06/05/2018).

Caso o usuário informe "Conta" e "Forma do pagamento", o sistema deve exibir as informações 
passadas em todas as parcelas.

Observação: Caso seja informado o dia 30 ou 31 no parcelamento, o sistema deve considerar 
o último dia do mês para os meses que não possuem 30 e 31.
*/
const handleGerarParcelas = (values, handleChange, valorBase) => {
  return () => {
    // Gambiarra para conseguir gerar novas parcelas sem gerar novas parcelas quando a origem é compra conforme pedido em GFST2021-37
    if (values?.origemLancamento?.includes('COMPRA')) {
      const parcelas = [];

      let vencimentoAnterior = values.dataVencimento;

      if (!moment.isMoment(vencimentoAnterior)) {
        vencimentoAnterior = moment(vencimentoAnterior);
      }

      for (let i = 0; i < values?.parcelasCompra?.length; ++i) {
        const dataVencimento = vencimentoAnterior.clone();

        if (i > 0) {
          dataVencimento.add(30, 'day');
        }

        parcelas.push({
          ...values.parcelasCompra[i],
          formaPagamento: values.formaPagamento,
          conta: values.conta,
          dataVencimento,
        });

        vencimentoAnterior = dataVencimento;
      }

      handleChange('retencoes', values.retencoesCompra);
      handleChange({ target: { id: 'parcelamento.parcelas', value: parcelas } });
      return;
    }

    if (values?.numeroParcelas && values?.dataVencimento) {
      const numero = values?.numeroParcelas;
      const parcelas = gerarParcelas(numero, values.dataVencimento, valorBase);

      const listaParcelas = parcelas.map((p) => {
        return {
          dataVencimento: p.dataVencimento,
          valorLiquido: p.valorParcela,
          formaPagamento: values.formaPagamento,
          conta: values.conta,
        };
      });
      handleChange({ target: { id: 'parcelamento.parcelas', value: listaParcelas } });
    }
  };
};

export const ContasPagarUtil = {
  calcularDiferencaParcelas,
  calcularDiferencaCategorias,
  calcularValorTotalBruto,
  calcularValorTotalLiquido,
  calcularValorCategoria,
  categoriaFormat,
  parcelaFormat,
  documentoFiscalFormat,
  contaBancariaFormat,
  verificarExibicaoBotaoExcluir,
  verificarExibicaoBotaoCancelarBaixa,
  verificarExibicaoBotaoBaixar,
  verificarExibicaoEditarVisualizar,
  calcularValorPagar,
  handleGerarParcelas,
  arredondaCasasDecimais,
  verificarBaixaConciliada,
  nomeImpostoFormat,
};

export const ContasPagarAction = {
  ...defaultActions,
  cadastrar: (init = initContasPagar) => defaultActions.cadastrar(init),
  carregarRegistros,
  setFiltroAvancado,
  setFiltroAvancadoFormatado,
  requestVisualizar,
  requestEditar,
  requestBaixa,
  excluir,
  fecharModalCadastro,
  onSubmit,
  buscarSomatorio,
  selecionarAbaCadastro,
  baixarContas,
  cancelarBaixas,
  buscarTour,
  abrirImportModal,
  fecharImportModal,
  setArquivoImport,
};
